<template>
	<div>
		<div style="color: #3e3e3e;margin-bottom: 15px;">
			门店数据>{{activeName=="three"?"数据实况":""}}{{activeName=="two"?"生熟客":""}}{{activeName=="one"?"数据列表":""}}{{activeName=="four"?"门店抖音数据":""}}
			{{activeName=="five"?"峰值客数":""}}{{activeName=="six"?"门店流失率":""}}{{activeName=="seven"?"发型师流失率":""}}
		</div>
		<el-tabs type="border-card" v-model="activeName">
			<el-tab-pane name="one" label="门店档案列表">
				<list3 v-if="activeName=='one'"></list3>
			</el-tab-pane>
			<el-tab-pane name="three" label="门店档案">
				<list1 v-if="activeName=='three'"></list1>
			</el-tab-pane>
			<el-tab-pane name="two" label="门店生熟客">
				<list2 v-if="activeName=='two'"></list2>
			</el-tab-pane>
			<el-tab-pane name="four" label="每月抖音销量">
				<list4 v-if="activeName=='four'"></list4>
			</el-tab-pane>
			<el-tab-pane name="five" label="峰值客数">
				<list5 v-if="activeName=='five'"></list5>
			</el-tab-pane>
			<el-tab-pane name="six" label="门店流失率">
				<list6 v-if="activeName=='six'"></list6>
			</el-tab-pane>
			<el-tab-pane name="seven" label="发型师流失率">
				<list7 v-if="activeName=='seven'"></list7>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
	import list1 from "./storeData1.vue"
	import list2 from "./storeData2.vue"
	import list3 from "./storeData3.vue"
	import list4 from "./storeData4.vue"
	import list5 from "./storeData5.vue"
	import list6 from "./storeData6.vue"
	import list7 from "./storeData7.vue"
	export default {
		components: {
			list1,
			list2,
			list3,
			list4,
			list5,
			list6,
			list7,
		},
		data() {
			return {
				activeName: "one"
			};
		},
		mounted() {
			if (this.$route.query.id == 1) {
				this.activeName = "one"
			}
			if (this.$route.query.id == 2) {
				this.activeName = "two"
			}
			if (this.$route.query.id == 3) {
				this.activeName = "three"
			}
			if (this.$route.query.id == 34) {
				this.activeName = "four"
			}
			if (this.$route.query.id == 3) {
				this.activeName = "five"
			}
		},
		methods: {
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
		},
	};
</script>
<style lang="less" scoped>
</style>